import React, {createContext, useContext, useCallback} from "react";
import useApiService from "./ApiService";
import CONFIG from "./CONFIG";

const ConnectionObjectMapApiContext = createContext(null);

export function ConnectionObjectMapApiProvider({children}) {

  const {get, post, put, del} = useApiService(CONFIG.SERVER_ORGANIZATION);

  const getConnectionObjectMap = useCallback(async (skip, limit) => {
    if (!skip) {
      skip = 0;
    }
    if (!limit) {
      limit = 10;
    }
    try {
      const response = await get(
        `/v1/connection_object_map?skip=${skip}&limit=${limit}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching connection object map:", error);
      throw error;
    }
  }, [get]);

  const getConnectionObjectMapById = useCallback(async (connectionObjectMapId) => {
    try {
      const response = await get(`/v1/connection_object_map/${connectionObjectMapId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching connection object map by ID:", error);
      throw error;
    }
  }, [get]);

  const createConnectionObjectMap = useCallback(async (connectionObjectMap) => {
    try {
      const response = await post(`/v1/connection_object_map`, connectionObjectMap);
      return response.data;
    } catch (error) {
      console.error("Error creating connection object map:", error);
      throw error;
    }
  }, [post]);

  const updateConnectionObjectMapById = useCallback(async (connectionObjectMapId, connectionObjectMap) => {
    try {
      const response = await put(`/v1/connection_object_map/${connectionObjectMapId}`, connectionObjectMap);
      return response.data;
    } catch (error) {
      console.error("Error updating connection object map:", error);
      throw error;
    }
  }, [put]);

  const deleteConnectionObjectMap = useCallback(async (connectionObjectMapId) => {
    try {
      const response = await del(`/v1/connection_object_map/${connectionObjectMapId}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting connection object map:", error);
      throw error;
    }
  }, [del]);

const getConnections = useCallback(async () => {
    try {
      const response = await get(
        `/v1/connections`
      );
      return response.data.items;
    } catch (error) {
      console.error("Error fetching connection:", error);
      throw error;
    }
  }, [get]);

  return (
    <ConnectionObjectMapApiContext.Provider value={{
      getConnectionObjectMap,
      getConnectionObjectMapById,
      createConnectionObjectMap,
      updateConnectionObjectMapById,
      deleteConnectionObjectMap,
      getConnections,
    }}>
      {children}
    </ConnectionObjectMapApiContext.Provider>
  );
}

export function useConnectionObjectMapApi() {
  const context = useContext(ConnectionObjectMapApiContext);
  if (!context) {
    throw new Error("useConnectionObjectMapApi must be used within a ConnectionObjectMapApiProvider");
  }
  return context;
}